var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .cls-4 {\n        fill: #fde9ec;\n      }\n\n      .cls-2 {\n        fill: #c32033;\n      }\n\n      .cls-3 {\n        fill: #dd1e34;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -0.9,
    y: -2.1,
    width: 87.8,
    height: 99.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4803.7-375.5h2500v2500h-2500V-375.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "42.2 3.6 42.2 3.6 42.2 3.6 1.3 18.2 7.6 72.2 42.2 91.4 42.2 91.4 42.2 91.4 76.8 72.2 83 18.2 42.2 3.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "42.2 3.6 42.2 13.4 42.2 13.3 42.2 57.8 42.2 57.8 42.2 91.4 42.2 91.4 76.8 72.2 83 18.2 42.2 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.2,13.3l-25.5,57.3h9.5l5.1-12.8h21.7l5.1,12.8h9.5L42.2,13.3h0ZM49.7,49.9h-14.9l7.5-17.9,7.5,17.9h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/Angular.294ecb1e227154621ff50410e7c4ea03.svg";
export { ForwardRef as ReactComponent };